import { posSettingsSchema } from "@redotech/redo-model/pos/settings";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updatePosSettings = {
  name: "updatePosSettings" as const,
  input: z.object({ teamId: zExt.objectId(), settings: posSettingsSchema }),
  output: z.object({}),
};
